<template>
  <div class="order">
    <nav-bar :sendInfo="info"></nav-bar>
    <div :class="isMobile ? 'p-content' : 'content'">
      <el-tabs v-model="activeName" @tab-click="handleClick" v-if="!isMobile">
        <el-tab-pane :label="$t('全部')" name="0">
          <div class="item-box" v-for="(item, index) in list" :key="index">
            <div class="item">
              <div class="item-left">
                <img src="../../assets/img/order.jpg" />
                <div class="left-box">
                  <div class="left">
                    <p>{{ $t("总佣金") }}</p>
                    <span>USD {{ item.commission }}</span>
                  </div>
                  <div class="right">
                    <p>{{ $t("存款本金") }}</p>
                    <span>USD {{ item.num }}</span>
                  </div>
                </div>
              </div>
              <div class="item-right" v-if="item.status == 1">
                <el-button style="background: #1e4de7; color: #fff" disabled>{{
                  $t("完成")
                }}</el-button>
              </div>
              <div class="item-right" v-if="item.status == 0">
                <el-button
                  style="background: #52037f; color: #fff"
                  @click="doOrder(item)"
                  >{{ $t("现在提交") }}</el-button
                >
              </div>
            </div>
          </div>
          <div class="empty" v-if="list.length == 0">
            <img src="../../assets/img/empty.png" />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('待定')" name="-1">
          <div class="item-box" v-for="(item, index) in list" :key="index">
            <div class="item">
              <div class="item-left">
                <img src="../../assets/img/order.jpg" />
                <div class="left-box">
                  <div class="left">
                    <p>{{ $t("总佣金") }}</p>
                    <span>USD {{ item.commission }}</span>
                  </div>
                  <div class="right">
                    <p>{{ $t("存款本金") }}</p>
                    <span>USD {{ item.num }}</span>
                  </div>
                </div>
              </div>
              <div class="item-right" v-if="item.status == 1">
                <el-button style="background: #1e4de7; color: #fff" disabled>{{
                  $t("完成")
                }}</el-button>
              </div>
              <div class="item-right" v-if="item.status == 0">
                <el-button
                  style="background: #52037f; color: #fff"
                  @click="doOrder(item)"
                  >{{ $t("现在提交") }}</el-button
                >
              </div>
            </div>
          </div>
          <div class="empty" v-if="list.length == 0">
            <img src="../../assets/img/empty.png" />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('完成')" name="1">
          <div class="item-box" v-for="(item, index) in list" :key="index">
            <div class="item">
              <div class="item-left">
                <img src="../../assets/img/order.jpg" />
                <div class="left-box">
                  <div class="left">
                    <p>{{ $t("总佣金") }}</p>
                    <span>USD {{ item.commission }}</span>
                  </div>
                  <div class="right">
                    <p>{{ $t("存款本金") }}</p>
                    <span>USD {{ item.num }}</span>
                  </div>
                </div>
              </div>
              <div class="item-right" v-if="item.status == 1">
                <el-button style="background: #1e4de7; color: #fff" disabled>{{
                  $t("完成")
                }}</el-button>
              </div>
              <div class="item-right" v-if="item.status == 0">
                <el-button
                  style="background: #1e4de7; color: #fff"
                  @click="doOrder(item)"
                  >{{ $t("做单") }}</el-button
                >
              </div>
            </div>
          </div>
          <div class="empty" v-if="list.length == 0">
            <img src="../../assets/img/empty.png" />
          </div>
        </el-tab-pane>
      </el-tabs>

      <el-tabs v-model="activeName" @tab-click="handleClick" v-else>
        <el-tab-pane :label="$t('全部')" name="0">
          <div class="item-box">
            <div class="item" v-for="(item, index) in list" :key="index">
              <img src="../../assets/img/order.jpg" />
              <div class="left-box">
                <div class="left">
                  <p>{{ $t("总佣金") }}</p>
                  <span>USD {{ item.commission }}</span>
                </div>
                <div class="right">
                  <p>{{ $t("存款本金") }}</p>
                  <span>USD {{ item.num }}</span>
                </div>
              </div>
              <div class="status" v-if="item.status == 1">{{ $t("完成") }}</div>
              <el-button
                v-if="item.status == 0"
                style="
                  background: #52037f;
                  color: #fff;
                  width: 80%;
                  margin: 10px auto 0 auto;
                "
                @click="doOrder(item)"
                >{{ $t("现在提交") }}</el-button
              >
            </div>
          </div>
          <div class="empty" v-if="list.length == 0">
            <img src="../../assets/img/empty.png" />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('待定')" name="-1">
          <div class="item-box">
            <div class="item" v-for="(item, index) in list" :key="index">
              <img src="../../assets/img/order.jpg" />
              <div class="left-box">
                <div class="left">
                  <p>{{ $t("总佣金") }}</p>
                  <span>USD {{ item.commission }}</span>
                </div>
                <div class="right">
                  <p>{{ $t("存款本金") }}</p>
                  <span>USD {{ item.num }}</span>
                </div>
              </div>
              <div class="status" v-if="item.status == 1">{{ $t("完成") }}</div>
              <el-button
                v-if="item.status == 0"
                style="
                  background: #52037f;
                  color: #fff;
                  width: 80%;
                  margin: 10px auto 0 auto;
                "
                @click="doOrder(item)"
                >{{ $t("现在提交") }}</el-button
              >
            </div>
          </div>
          <div class="empty" v-if="list.length == 0">
            <img src="../../assets/img/empty.png" />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('完成')" name="1">
          <div class="item-box">
            <div class="item" v-for="(item, index) in list" :key="index">
              <img src="../../assets/img/order.jpg" />
              <div class="left-box">
                <div class="left">
                  <p>{{ $t("总佣金") }}</p>
                  <span>USD {{ item.commission }}</span>
                </div>
                <div class="right">
                  <p>{{ $t("存款本金") }}</p>
                  <span>USD {{ item.num }}</span>
                </div>
              </div>
              <div class="status">{{ $t("完成") }}</div>
              <!-- <el-button
                v-if="item.status == 0"
                style="
                  background: #1e4de7;
                  color: #fff;
                  width: 80%;
                  margin: 10px auto 0 auto;
                "
                @click="doOrder(item)"
                >{{ $t("做单") }}</el-button
              > -->
            </div>
          </div>
          <div class="empty" v-if="list.length == 0">
            <img src="../../assets/img/empty.png" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 做单信息 -->
    <el-dialog
      :visible.sync="orderDialog"
      :width="isMobile ? '80%' : '55%'"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
    <div style="display: flex; align-items: center">
        <div ref="lineChart" style="width: 350px; height: 350px"></div>
        <div class="dialog">
          <span slot="title" class="title" style="color: #fff">
            {{ $t("算力收益参考") }}
          </span>
          <div class="d-body" style="margin-top: 10px">
            <div class="cpt">
              {{ $t("计算能力") }} <span>{{ orderInfo.commission }}</span
              >TH/s ≈ 0.00000074 BTC ≈ $0.05 rate<span>0%</span>
              {{ $t("收入模式") }}：{{ $t("加速") }}
            </div>
            <div class="account">
              <div class="account-item">
                <span>{{ $t("账户余额") }}</span>
                <span>{{ info.balance }}</span>
              </div>
              <div class="account-item">
                <span>{{ $t("进展速度") }}</span>
                <div class="right">
                  <el-progress
                    :text-inside="true"
                    :stroke-width="isMobile ? 16 : 22"
                    :percentage="process"
                  ></el-progress>
                </div>
              </div>
              <div class="account-item">
                <span>{{ $t("困难") }}</span>
                <span>100%</span>
              </div>
            </div>
            <div style="text-align: center; margin: 20px 0">
              {{ $t("矿物开采") }}
            </div>
            <!-- <div class="loader">
              <div
                class="circle"
                v-for="(color, index) in colors"
                :key="index"
                :style="{
                  backgroundColor: color,
                  animationDelay: index * 0.1 + 's',
                }"
              ></div>
            </div> -->
            <div class="loader">
              <div class="circle" v-for="(color, index) in colors"
                  :key="index"
                  :style="{ backgroundColor: color, opacity: isActive(index) ? 1 : 0.2 }"></div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <footers v-if="!isMobile"></footers>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { mapGetters } from "vuex";
import { doOrder, record, orderInfo, info } from "../../api/index";
export default {
  data() {
    return {
      activeName: "0",
      list: [],
      orderDialog: false,
      process: 0,
      orderInfo: {},
      info: {},
      colors: [
        "#b63036",
        "#ffeb2b",
        "#7fff00",
        "#74daff",
        "#4caf50",
        "#fa49ff",
      ],
      activeIndex: 0,
      intervalId: null,
      pastDates: [], // 日期
    };
  },
  computed: {
    ...mapGetters("device", ["isMobile"]),
  },
  created() {
    this.getList(this.activeName);
    this.startAnimation();
    this.getProcess()
  },
  mounted() {
    this.getWallet()
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    startAnimation() {
      this.intervalId = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.colors.length;
      }, 500); // 每秒切换一次
    },
    isActive(index) {
      return index === this.activeIndex;
    },
    // 随机数据 、日期
    formatTime(date) {
      const hours = String(date.getHours()).padStart(2, '0'); // 格式化小时
      const minutes = String(date.getMinutes()).padStart(2, '0'); // 格式化分钟
      const seconds = String(date.getSeconds()).padStart(2, '0'); // 格式化秒
      return `${hours}:${minutes}:${seconds}`; // 格式化为 "HH:MM:SS"
    },
    getPastDates() {
      const now = new Date();
      const slots = [];

      for (let i = 0; i < 8; i++) { // 0到7表示过去的每个四分钟的时间点
        const pastTime = new Date(now);
        pastTime.setMinutes(now.getMinutes() - (i * 4)); // 每次减去4分钟
        const formattedTime = this.formatTime(pastTime);
        slots.push(formattedTime);
      }

      this.pastDates = slots.reverse(); // 反转数组以从最新到最旧显示
    },
    // echarts
    initLineChart(money) {
      this.$nextTick(() => {
        const chartDom = this.$refs.lineChart;
        const myChart = echarts.init(chartDom);
        const numbers = [];
        for (let i = 0; i < 8; i++) {
          const randomNum = Math.floor(Math.random() * (Number(money) + 100 + 1)); // 生成 0 到 (baseNumber + 100) 的随机数
          numbers.push(randomNum);
        }
        const option = {
          tooltip: {
            trigger: 'axis',
            position: function (pt) {
              return [pt[0], '10%'];
            }
          },
          title: {
            left: 'center',
            text: ''
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.pastDates
          },
          yAxis: {
            type: 'value',
            splitLine: {
                show: true,
                lineStyle: {
                    // 修改为你想要的颜色
                    color: '#226491'
                }
            }
          },
          series: [
            {
              name: '',
              type: 'line',
              symbol: 'none',
              sampling: 'lttb',
              itemStyle: {
                color: '#226491'
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#226491'
                  },
                  {
                    offset: 1,
                    color: '#226491'
                  }
                ])
              },
              data: numbers
            }
          ]
        }
        myChart.setOption(option);
      });
    },
    getWallet() {
      info().then((res) => {
        if (res.code == 0) {
          this.info = res.data.info;
          this.getPastDates()
          localStorage.setItem("info", JSON.stringify(this.info));
        }
      });
    },
    // 获取做单进度
    getProcess() {
      orderInfo().then((res) => {
        if (res.code == 0) {
          var result = res.data;
          this.$nextTick(() => {
            this.process = Number(
              (
                (Number(result.day_d_count) / Number(result.order_num)) *
                100
              ).toFixed(0)
            );
          });
        }
      });
    },
    getList(status) {
      record({ status: status, page: "1", size: "50" }).then((res) => {
        if (res.code == 0) {
          this.list = res.data.list;
        }
      });
    },
    // 完成做单
    doOrder(item) {
      this.orderDialog = true;
      this.orderInfo = item
      this.initLineChart(this.info.balance)
      setTimeout(() => {
          doOrder({status: 1, oid:item.id}).then(res=> {
            if (res.code == 0) {
                this.$message({
                    message: res.info,
                    type: 'success'
                })
                this.orderDialog = false
                this.getList(this.activeName)
            }
            setTimeout(() => {
              window.location.reload()
            }, 1000);
        }).catch(()=> {
          window.location.reload()
        })
      }, 3000);
    },
    handleClick(tab, event) {
      this.getList(this.activeName);
    },
  },
};
</script>

<style lang="scss" scoped>
.order {
  background-color: #fff;

  :deep(.el-dialog) {
    background: #1f3f7a;
    color: #fff;
    font-size: 14px;
  }
  .d-body {
    color: #fff;

    .cpt {
      display: flex;
      align-items: center;

      span {
        display: inline-block;
        border: 1px solid #fff;
        padding: 2px 10px;
        border-radius: 5px;
        margin: 0 10px;
      }
    }

    .account {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;
      padding: 10px 0;
      border-top: 1px solid #a89d9d;
      border-bottom: 1px solid #a89d9d;

      .account-item {
        width: 33%;
        display: flex;
        flex-direction: column;
        align-items: center;

        span {
          margin-bottom: 10px;
        }
      }
    }

    .right {
      width: 100%;
      position: relative;

      span {
        position: absolute;
        top: 2px;
        right: 0;
      }

      :deep(.el-progress-bar) {
        /* width: 80%; */
      }
    }

    .loader {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .circle {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      margin: 0 5px;
      /* animation: bounce 1s infinite alternate; */
      transition: opacity 0.5s ease;
    }

    /* .circle-box {
      display: flex;
      justify-content: center;
      align-items: center;

      .circle {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        margin-right: 5px;
      }

      .c1 {
        background: #b63036;
      }
      .c2 {
        background: #ffeb2b;
      }
      .c3 {
        background: #7fff00;
      }
      .c4 {
        background: #74daff;
      }
      .c5 {
        background: #b63036;
      }
      .c6 {
        background: #fa49ff;
      }
    } */
  }
  .content {
    width: 62%;
    margin: 40px auto 20px auto;

    .item-box {
      display: flex;
      flex-direction: column;

      .item {
        display: flex;
        justify-content: space-between;
        padding: 10px 30px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px 0 rgba(99, 99, 99, 0.2);
        margin-bottom: 20px;
        margin-top: 20px;

        img {
          width: 200px;
          height: 150px;
          border-radius: 6px;
        }

        .item-left {
          display: flex;

          .left-box {
            display: flex;
            padding: 0 20px;

            .left,
            .right {
              width: 180px;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-right: 20px;

              p {
                color: #5a5a5a;
                font-size: 16px;
              }

              span {
                font-size: 20px;
                color: #000;
              }
            }
          }
        }

        .item-right {
        }
      }
    }

    .empty {
      width: 338px;
      height: 292px;
    }

    :deep(.el-tabs__item) {
      color: rgb(153, 153, 153);
      width: 100px;
      text-align: center;
    }
    :deep(.el-tabs__item.is-active) {
      color: #000;
    }
    :deep(.el-tabs__active-bar) {
      height: 3px;
      background-color: #000;
    }
    :deep(.el-tabs__nav-wrap::after) {
      height: 3px;
    }
  }

  .p-content {
    /* padding: 10px; */

    :deep(.el-tabs__nav-scroll) {
      padding: 0 10px;
      background-color: rgb(62, 96, 207);
    }

    :deep(.el-tabs__item) {
      width: 33%;
      color: rgb(153, 153, 153);
      text-align: center;
    }
    :deep(.el-tabs__item.is-active) {
      color: #fff;
    }
    :deep(.el-tabs__active-bar) {
      height: 3px;
      background-color: #fff;
    }
    :deep(.el-tabs__nav-wrap::after) {
      height: 3px;
    }
    :deep(.el-tabs__nav) {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .item-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 10px;

      .item {
        width: 48.5%;
        display: flex;
        flex-direction: column;
        padding: 0 0 30px 0;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px 0 rgba(99, 99, 99, 0.2);
        margin-bottom: 20px;
        border-radius: 9px;
        position: relative;

        img {
          width: 100%;
          height: 160px;
          border-radius: 9px 9px 0 0;
        }

        .status {
          width: 60%;
          color: #fff;
          text-align: center;
          font-size: 14px;
          padding: 4px 0;
          border-radius: 9px 0 9px 0;
          background: #745ddd;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 10;
        }

        .left-box {
          font-size: 14px;
          padding: 0 5px;

          p {
            color: #5a5a5a;
          }

          span {
            font-size: 16px;
            color: #000;
          }
        }
      }
    }

    .empty {
      width: 100%;
    }
  }
}
</style>
